import { StyleSheet } from 'react-native';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  lineStyle: (width, height, style) => ({
    width,
    height,
    ...style,
  }),
  circleStyle: {
    width: 35,
    height: 35,
    marginRight: 15,
  },
  buttonStyle: marginTop => ({
    width: 296,
    height: 41,
    marginTop: marginTop,
    borderRadius: 5,
  }),
  marginStyle: (marginTop, marginBottom, marginRight, marginLeft) => ({
    marginTop,
    marginBottom,
    marginRight,
    marginLeft,
  }),
  squareStyle: marginBottom => ({
    width: 94,
    height: 16,
    marginBottom,
  }),
  squareContainerStyle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 3,
  },
  divider: {
    height: 1,
    marginBottom: 29,
  },

  loadingContentStyle: theme => ({
    marginTop: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.3,
    ...cardShadow,
    paddingVertical: 24,
  }),
  contentPadding: {
    paddingHorizontal: 16,
  },
});
